// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"NotificationPanel_mobileOnly__mkOes","mobileHidden":"NotificationPanel_mobileHidden__fK4iz"};